export default __webpack_public_path__ + "static/media/silhouetteStudent.18327ec9.png";